import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
  excelWorksheetName,
  toYesNo,
} from "./principle6SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Environmental impact";

const SHEET_TITLE =
  "Details of environmental impact assessments of projects undertaken by the entity based on applicable laws, in the current financial year:";

function projectDetails(item) {
  const name = safeText(item?.nameOfProject, "");
  const brief = safeText(item?.projectBrief, "");
  if (name && brief && name !== "-" && brief !== "-") return `${name} ${brief}`.trim();
  if (name && name !== "-") return name;
  if (brief && brief !== "-") return brief;
  return "-";
}

export function buildEnvironmentalImpactSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(excelWorksheetName(SHEET_NAME), {
    views: [{ showGridLines: true }],
  });

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 40;
  ws.getColumn("F").width = 18;
  ws.getColumn("G").width = 14;
  ws.getColumn("H").width = 28;
  ws.getColumn("I").width = 24;
  ws.getColumn("J").width = 36;

  const rows = sectionC?.principle6?.essentialIndicators?.projectUndertakenByentity || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, { mergeEnd: COL_J });

  mergeRow(ws, TITLE_ROW, COL_D, COL_J, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Name and brief details of project", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_F, "EIA Notification No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, "Date", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_H, "Whether conducted by independent external agency (Yes / No)", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_I, "Results communicated in public domain (Yes / No)", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_J, "Relevant Web link", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, projectDetails(item), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.EIANotification), { align: "center" });
    setCell(ws, row, COL_G, safeText(item?.dateOfNotification), { align: "center" });
    setCell(ws, row, COL_H, toYesNo(item?.extenalAgecy), { align: "center" });
    setCell(ws, row, COL_I, toYesNo(item?.publicDomain), { align: "center" });
    setCell(ws, row, COL_J, safeText(item?.link, ""), { align: "left" });
  });

  return ws;
}
